module.exports = __webpack_public_path__ + "img/en-logo-name.3dc3667c.svg";